<template>
  <div class="root" v-title :data-title="title">
    <Template001 v-if="isStyle001()" :view_key="viewKey"></Template001>
    <Template002 v-else-if="isStyle002()" :view_key="viewKey"></Template002>
    <Template003 v-else-if="isStyle003()" :view_key="viewKey"></Template003>
    <Template004 v-else-if="isStyle004()" :view_key="viewKey"></Template004>
    <Template000 v-else></Template000>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Template000 from './template/Template-000.vue';
import Template001 from './template/Template-001.vue';
import Template002 from './template/Template-002.vue';
import Template003 from './template/Template-003.vue';
import Template004 from './template/Template-004.vue';
import TemplateRequest from '../data/TemplateRequest';
import { TemplateStyle } from '../data/TemplateData';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';

const templateStyle = ref<TemplateStyle>(TemplateStyle.TemplateStyle000);
const { t } = useI18n();

const viewKey = ref<string>('');

const title = ref(t('common.wpsOffice'));

function isStyle001() {
  return templateStyle.value === TemplateStyle.TemplateStyle001;
}

function isStyle002() {
  return templateStyle.value === TemplateStyle.TemplateStyle002;
}

function isStyle003() {
  return templateStyle.value === TemplateStyle.TemplateStyle003;
}

function isStyle004() {
  return templateStyle.value === TemplateStyle.TemplateStyle004;
}

onBeforeMount(() => {
  viewKey.value = AbilityParamsUtil.getViewKey();
  var shareObj = AbilityParamsUtil.getShareObj();
  var shareContent = shareObj.share_content;
  if (
    shareContent !== undefined &&
    shareContent != null &&
    shareContent.title != undefined &&
    shareContent.title != ''
  ) {
    title.value = shareContent.title;
  }
  templateStyle.value = TemplateRequest.getTemplateStyle(viewKey.value);
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.root {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
</style>
